<template>
  <div>
    <div class="breadcrumb" style="background: #fff">编辑SKU组</div>
    <div class="third-title"><span>SKU组特殊价格信息</span></div>
    <el-form ref="form" style="background:#fff;padding:20px 0 20px 50px" :model="form" label-width="80px">
      <el-form-item label="平台号:">
        <span>111</span>
      </el-form-item>
      <el-form-item label="申请价格:">
        <el-button style="margin-bottom:20px" type="primary" round>修改</el-button>
      </el-form-item>
      <el-form-item label="申请价格:">
        <el-radio v-model="radio" label="1">备选项</el-radio>
        <el-radio v-model="radio" label="2">备选项</el-radio>
      </el-form-item>
      <el-form-item label="申请价格:">
        <el-table :data="tableData" border style="width: 810px">
          <el-table-column prop="date" label="SKU名称"></el-table-column>
          <el-table-column prop="name" width="80px" label="基础P数"></el-table-column>
          <el-table-column prop="address" width="80px" label="最大P数"></el-table-column>
          <el-table-column prop="address" width="110px" label="一次增加P数"></el-table-column>
          <el-table-column prop="address" label="基础P平台价格"></el-table-column>
          <el-table-column prop="address" label="增加一次平台价格"></el-table-column>
          <el-table-column prop="address" label="申请基础P数价格"></el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary">返回</el-button>
    </div>
  </div>
</template>
 <script>
export default {
  data () {
    return {
      radio: '',
      form: {}
    }
  }
}
</script>
 <style>
</style>
